export default __webpack_public_path__ + "static/media/crossIcon.3c265f5b.svg";